var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#0B966B",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3.429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0v2.286M13.657 2.343l-1.616 1.616M16 8h-2.286M13.657 13.657l-1.616-1.616M8 16v-2.286M2.343 13.657l1.616-1.616M0 8h2.286M2.343 2.343l1.616 1.616"
  }))));
}
export default SvgIconSun;